import React, { useState, useEffect } from "react";

const PasswordCellEditor = (props) => {
    const { value, onValueChange } = props;
    const [password, setPassword] = useState(value?.password || "");
    const [password_confirmation, setPassword_confirmation] = useState(value?.password_confirmation || "");

    useEffect(() => {
        onValueChange({ password, password_confirmation });
    }, [onValueChange, password, password_confirmation]);

    const onBlur = () => {
        //props.stopEditing();
    };

    return (
        <div>
          <div class="double-editor-div-1">
              <input
                  className="double-editor-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onBlur={onBlur}
                  placeholder="Password"
                  autoFocus
              />
          </div>
          <div class="double-editor-div-2">
              <input
                  id="double-editor-input-2"
                  className="double-editor-input"
                  type="password"
                  value={password_confirmation}
                  onChange={(e) => setPassword_confirmation(e.target.value)}
                  onBlur={onBlur}
                  placeholder="Conferma Password"
              />
          </div>
        </div>
    );
};

export default PasswordCellEditor;
